<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M9.16663 15L4.16663 10L9.16663 5L10.3333 6.16667L6.52079 10L10.3333 13.8333L9.16663 15ZM14.6666 15L9.66663 10L14.6666 5L15.8333 6.16667L12.0208 10L15.8333 13.8333L14.6666 15Z" fill="#333333"/>
</svg>
